import alt from "../alt";
import indexBy from "lodash/keyBy";
import values from "lodash/values";
import VirtualContentUtil from "../utils/VirtualContentUtil";
import VirtualContentActions from "../actions/VirtualContentActions";
import UserStore from "../stores/UserStore";

class VirtualContentStore {
  constructor() {
    this.bindActions(VirtualContentActions);

    this.state = {
      virtualContents: {},
      reviewQueues: {},
      isFetching: false,
      isEditing: null,
      isCreating: false,
      newVirtualContentId: null
    };

    this.exportPublicMethods({
      getVirtualContentById: this.getVirtualContentById.bind(this),
      getVirtualContent: this.getVirtualContent.bind(this)
    });
  }

  getVirtualContentById(id) {
    return this.state.virtualContents[id];
  }

  getVirtualContent(id) {
    return values(this.state.virtualContents);
  }

  onFetchAll() {
    this.setState({ isFetching: true });
    VirtualContentUtil.fetchAll(UserStore.getState().apiKey)
      .then(data => {
        VirtualContentActions.updateVirtualContents(indexBy(data, "id"));
        this.setState({ isFetching: false });
      })
      .catch(VirtualContentActions.fetchFailed);
  }

  onFetchByIds(ids) {
    this.setState({ isFetching: true });
    VirtualContentUtil.fetchByIds(UserStore.getState().apiKey, ids)
      .then(data => {
        VirtualContentActions.updateVirtualContents(indexBy(data, "id"));
        this.setState({ isFetching: false });
      })
      .catch(VirtualContentActions.fetchFailed);
  }

  onFetchOne(id) {
    this.setState({ isFetching: true });
    VirtualContentUtil.fetchOne(UserStore.getState().apiKey, id)
      .then(data => {
        VirtualContentActions.updateVirtualContent(id, data);
        this.setState({ isFetching: false });
      })
      .catch(VirtualContentActions.fetchFailed);
  }

  onEdit(newData) {
    this.setState({ isEditing: newData.id });
    VirtualContentUtil.edit(
      UserStore.getState().apiKey,
      newData.id,
      newData.values
    )
      .then(data => {
        VirtualContentActions.updateVirtualContent(newData.id, data);
        this.setState({ isEditing: null });
      })
      .catch(VirtualContentActions.editFailed);
  }

  onDelete(id) {
    VirtualContentUtil.delete(UserStore.getState().apiKey, id)
      .then(data => {
        VirtualContentActions.updateVirtualContent(id, undefined);
      })
      .catch(VirtualContentActions.editFailed);
  }

  onCreate(newData) {
    this.setState({ isCreating: true, newVirtualContentId: null });

    VirtualContentUtil.create(UserStore.getState().apiKey, newData)
      .then(data => {
        VirtualContentActions.updateVirtualContent(data.id, data);
        this.setState({ isCreating: false, newVirtualContentId: data.id });
      })
      .catch(VirtualContentActions.editFailed);
  }

  onUpdateVirtualContents(virtualContents) {
    this.setState({
      virtualContents: { ...this.state.virtualContents, ...virtualContents }
    });
  }

  onUpdateVirtualContent(data) {
    if (!data.virtualContent) {
      delete this.state.virtualContents[data.id];
    } else {
      this.state.virtualContents[data.id] = data.virtualContent;
    }
    this.state.newVirtualContentId = null;
    this.setState(this.state);
  }

  onFetchFailed(e) {
    alert(`Fetching virtual content failed: ${e.message}`);
    throw e;
  }

  onEditFailed(e) {
    alert(`Edit failed: ${e.message}`);
    this.setState({ isCreating: false, isEditing: false });
  }

  onStartStreaming(id) {
    this.setState({ isEditing: true });
    return VirtualContentUtil.startStreaming(UserStore.getState().apiKey, id)
      .then(data => {
        this.setState({ isEditing: false });
      })
      .catch(VirtualContentActions.editFailed);
  }

  onStopStreaming(id) {
    this.setState({ isEditing: true });
    return VirtualContentUtil.stopStreaming(UserStore.getState().apiKey, id)
      .then(data => {
        this.setState({ isEditing: false });
      })
      .catch(VirtualContentActions.editFailed);
  }

  onFetchChatReviewQueue(data) {
    return VirtualContentUtil.fetchChatReviewQueue(
      UserStore.getState().apiKey,
      data.virtualContentId,
      data.options
    )
      .then(responseData => {
        this.state.reviewQueues[data.virtualContentId] = responseData;
        this.setState(this.state);
      })
      .catch(VirtualContentActions.editFailed);
  }

  onSubmitChatReviewAction(data) {
    return VirtualContentUtil.submitChatReviewAction(
      UserStore.getState().apiKey,
      data.virtualContentId,
      data.options
    )
      .then(responseData => {
        console.log(responseData);
      })
      .catch(VirtualContentActions.editFailed);
  }
}

export default alt.createStore(VirtualContentStore, "VirtualContentStore");



// WEBPACK FOOTER //
// ./src/app/stores/VirtualContentStore.js